(() => {
  if (customElements.get('extro-recommendations')) return;
  const key = 'extro:recommendations:v1', ttl = 4 * 60 * 60 * 1000;
  const root = window.Shopify?.routes?.root || '/';
  const allowed = () => window.Shopify?.customerPrivacy?.preferencesProcessingAllowed?.() === true;
  const empty = () => ({products: [], collections: [], seen: []});
  function history() {
    if (!allowed()) return empty();
    try {
      const data = JSON.parse(sessionStorage.getItem(key));
      return data && Date.now() - data.time < ttl && ['products','collections','seen'].every(k=>Array.isArray(data[k])) ? data : empty();
    } catch { return empty(); }
  }
  function save(data) {
    if (!allowed()) return;
    try { sessionStorage.setItem(key, JSON.stringify({...data, time: Date.now()})); } catch { /* Storage disabilitato: consigli contestuali. */ }
  }
  function record() {
    // Unknown while Shopify loads is not a revocation: leave existing session data untouched.
    if (!window.Shopify?.customerPrivacy?.preferencesProcessingAllowed) return;
    if (!allowed()) { try { sessionStorage.removeItem(key); } catch {} return; }
    const node = document.querySelector('[data-extro-navigation]');
    if (!node) return;
    const context = JSON.parse(node.textContent), data = history();
    if (context.product) data.products = [context.product, ...data.products.filter(p=>p.id!==context.product.id)].slice(0,8);
    if (context.collection) data.collections = [context.collection,...data.collections.filter(c=>c.handle!==context.collection.handle)].slice(0,4);
    save(data);
  }
  record();
  if (!window.Shopify?.customerPrivacy && window.Shopify?.loadFeatures) {
    window.Shopify.loadFeatures([{name:'consent-tracking-api',version:'0.1'}],error=>{ if (!error) record(); });
  }
  document.addEventListener('visitorConsentCollected',()=>{
    record();
    document.querySelectorAll('extro-recommendations').forEach(el=>el.refresh());
  });
  function bounded(promise) {
    return new Promise((resolve,reject)=>{
      const timer=setTimeout(()=>reject(Error('Recommendation timeout')),6000);
      promise.then(value=>{clearTimeout(timer);resolve(value);},error=>{clearTimeout(timer);reject(error);});
    });
  }
  async function json(url, signal) {
    const response = await fetch(url, {signal});
    if (!response.ok) throw Error('Recommendations response '+response.status);
    return response.json();
  }
  function safeURL(value) {
    try { const url = new URL(value, location.origin); return ['https:','http:'].includes(url.protocol) ? url.href : ''; } catch { return ''; }
  }
  function localProductURL(p) {
    const value = safeURL(p.url);
    if (!value) return '';
    const u = new URL(value);
    if (u.origin !== location.origin) return '';
    // Preserve Shopify recommendation attribution query parameters.
    if (!u.pathname.startsWith(root+'products/')) u.pathname = root+'products/'+encodeURIComponent(p.handle || u.pathname.split('/').pop());
    return u.href;
  }
  // Markup del tema, riutilizzato solo per i prodotti scelti dal ranking.
  const cardCache = new Map();
  let instance = 0;
  function standardCard(product) {
    const url = new URL(localProductURL(product));
    url.search = '';
    url.searchParams.set('section_id', 'extro-recommendation-card');
    const key = url.href;
    if (!cardCache.has(key)) {
      const request = bounded(fetch(key).then(response => {
        if (!response.ok) throw Error('Card response '+response.status);
        return response.text();
      })).then(html => {
        const card = new DOMParser().parseFromString(html,'text/html').querySelector('product-item');
        if (!card) throw Error('Card non disponibile');
        return card;
      }).catch(error => { cardCache.delete(key); throw error; });
      cardCache.set(key, request);
      if (cardCache.size > 64) cardCache.delete(cardCache.keys().next().value);
    }
    return cardCache.get(key);
  }
  async function prepareCards(products) {
    const pending = products.filter((p,index,all)=>/^[a-z0-9-]+$/.test(p.handle || '') && all.findIndex(other=>other.handle===p.handle)===index).filter(p=>{
      const url=new URL(localProductURL(p));url.search='';url.searchParams.set('section_id','extro-recommendation-card');
      return !cardCache.has(url.href);
    });
    // Shopify permette al massimo 20 lookup all_products nella stessa risposta.
    for(let offset=0;offset<pending.length;offset+=20) {
      const batch=pending.slice(offset,offset+20),url=new URL(root+'search',location.origin);
      url.searchParams.set('q',batch.map(p=>p.handle).join('|'));
      url.searchParams.set('section_id','extro-recommendation-cards');
      try {
        const response=await bounded(fetch(url));if(!response.ok)continue;
        const html=await bounded(response.text());
        const template=new DOMParser().parseFromString(html,'text/html').querySelector('template[data-extro-cards]');
        if(!template)continue;
        for(const product of batch) {
          const card=template.content.querySelector(`product-item[data-extro-product-id="${product.id}"]`);
          if(!card)continue;
          const key=new URL(localProductURL(product));key.search='';key.searchParams.set('section_id','extro-recommendation-card');
          cardCache.set(key.href,Promise.resolve(card));
          if(cardCache.size>64)cardCache.delete(cardCache.keys().next().value);
        }
      } catch { /* La richiesta singola esistente resta il ripiego per errori o prodotti mancanti. */ }
    }
  }
  class Recommendations extends HTMLElement {
    connectedCallback() {
      if (this.connected) return;
      this.connected = true;
      this.cardPrefix ||= `er-${++instance}`;
      try { this.context = JSON.parse(this.querySelector('[data-context]').textContent); } catch { return; }
      this.setupScrollProgress();
      this.onCart = () => {
        if (this.context.mode==='cart') {
          this.controller=null;
          const group=this.querySelector('[data-group="related"]');
          group.hidden=true;group.querySelector('.er-rail').replaceChildren();
        }
        this.refresh();
      };
      document.addEventListener('cart:updated',this.onCart);
      this.observer = new IntersectionObserver(entries=>{
        if (entries.some(e=>e.isIntersecting)) { this.observer.disconnect(); this.started=true; this.refresh(); }
      },{rootMargin:'600px'});
      this.observer.observe(this);
    }
    disconnectedCallback() {
      this.connected=false; this.controller=null; this.observer?.disconnect();
      document.removeEventListener('cart:updated',this.onCart);
    }
    setupScrollProgress() {
      this.querySelectorAll('.er-rail').forEach(rail=>{
        if(rail.parentElement.querySelector('extro-scroll-progress'))return;
        const bar=document.createElement('extro-scroll-progress');
        bar.className='er-progress gallery__progress-bar progress-bar';
        bar.setAttribute('rail-selector','.er-rail');
        bar.setAttribute('aria-hidden','true');bar.hidden=true;rail.after(bar);
      });
      this.updateScrollProgress=()=>this.querySelectorAll('extro-scroll-progress').forEach(bar=>bar.updateProgress?.());
    }
    async pool(collection, signal) {
      if (!collection || !/^[a-z0-9-]+$/.test(collection.handle)) return [];
      const pages = Math.max(1,Math.ceil((Number(collection.count)||24)/24));
      const page = 1 + Math.floor(Math.random()*pages);
      const url = new URL(root+'collections/'+collection.handle,location.origin);
      url.searchParams.set('section_id','extro-recommendation-pool');url.searchParams.set('page',page);
      const response = await fetch(url,{signal});
      if (!response.ok) return [];
      const doc = new DOMParser().parseFromString(await response.text(),'text/html');
      const data = doc.querySelector('[data-extro-pool]');
      return data ? JSON.parse(data.textContent).products : [];
    }
    async similar(current, signal) {
      const word = String(current.title || '').split(/\s+/)[0].toLowerCase();
      if (word.length < 3) return [];
      const url = new URL(root+'search', location.origin);
      url.searchParams.set('q', (word.length > 5 ? word.slice(0,-1) : word)+'*');
      url.searchParams.set('type','product');
      url.searchParams.set('options[unavailable_products]','hide');
      url.searchParams.set('section_id','extro-recommendation-pool');
      const response=await fetch(url,{signal});if(!response.ok)return [];
      const node=new DOMParser().parseFromString(await response.text(),'text/html').querySelector('[data-extro-pool]');
      return node?JSON.parse(node.textContent).products:[];
    }
    async cartOutfitProducts(anchors, controller) {
      const groups=new Array(anchors.length);
      let cursor=0;
      // Stessa fonte di COMPLETA IL TUO OUTFIT in scheda prodotto, senza mescolare l'ordine.
      const complements=Promise.all(Array.from({length:Math.min(3,anchors.length)},async()=>{
        while(cursor<anchors.length && this.controller===controller) {
          const index=cursor++;
          try {const data=await bounded(json(root+`recommendations/products.json?product_id=${encodeURIComponent(anchors[index].product.id)}&intent=complementary&limit=10`));groups[index]=data.products || [];}
          catch {groups[index]=[];}
        }
      }));
      const affordable=(async()=>{
        const products=[];
        // Catalogo ordinato per prezzo: un massimo di tre pagine, solo articoli disponibili sotto 30€.
        for(let page=1;page<=3 && this.controller===controller;page++) {
          try {
            const url=new URL(root+'collections/all',location.origin);
            url.searchParams.set('sort_by','price-ascending');url.searchParams.set('page',page);
            url.searchParams.set('section_id','extro-cart-outfit-pool');
            const response=await bounded(fetch(url));if(!response.ok)break;
            const el=new DOMParser().parseFromString(await bounded(response.text()),'text/html').querySelector('[data-outfit-pool]');
            const data=JSON.parse(el.textContent);products.push(...data.products);
            if(!data.more || products.length>=80)break;
          } catch {break;}
        }
        return products;
      })();
      const [,lowcost]=await Promise.all([complements,affordable]);
      return window.ExtroRecommendationRanking.selectCartOutfit(groups,lowcost,{anchors:anchors.map(a=>a.product),limit:40,variety:0.15});
    }
    async refreshCart() {
      const controller=this.controller={};
      this.setAttribute('aria-busy','true');
      try {
        // Contesto Liquid aggiornato: tag, tipologie e collezioni di TUTTI i prodotti attuali.
        const response=await bounded(fetch(root+'cart?section_id=extro-cart-recommendation-context', {cache:'no-store'}));
        if(!response.ok)throw Error('Cart context unavailable');
        const node=new DOMParser().parseFromString(await bounded(response.text()),'text/html').querySelector('[data-extro-cart-context]');
        const context=JSON.parse(node.textContent);
        if(this.controller!==controller)return;
        const anchors=[...new Map(context.anchors.filter(a=>a.product).map(a=>[String(a.product.id),a])).values()];
        if(!anchors.length) { await this.render('related',[],controller);this.dataset.loaded='true';return; }
        if(this.hasAttribute('data-outfit')) {
          const selected=await this.cartOutfitProducts(anchors,controller);
          if(this.controller!==controller)return;
          await this.render('related',selected,controller);
          this.dataset.loaded='true';
          return;
        }
        const ranking=window.ExtroRecommendationRanking;
        // Per carrelli grandi distribuisce le fonti fra categorie, con massimo sei semi.
        // Il punteggio e le esclusioni considerano comunque tutti i prodotti.
        const shuffled=[...anchors], seeds=[], kinds=new Set();
        for(let i=shuffled.length-1;i>0;i--){const j=Math.floor(Math.random()*(i+1));[shuffled[i],shuffled[j]]=[shuffled[j],shuffled[i]];}
        for(const a of shuffled)if(!kinds.has(ranking.kind(a.product))){seeds.push(a);kinds.add(ranking.kind(a.product));}
        for(const a of shuffled)if(!seeds.includes(a))seeds.push(a);
        const sources=seeds.slice(0,6), candidates=[];
        const jobs=sources.flatMap(a=>['complementary','related'].map(intent=>()=>json(root+`recommendations/products.json?product_id=${encodeURIComponent(a.product.id)}&intent=${intent}&limit=10`).then(d=>(d.products||[]).map(p=>({...p,native:true,complementary:intent==='complementary'})))));
        const collections=[...new Map(sources.flatMap(a=>a.collections||[]).map(c=>[c.handle,c])).values()].slice(0,3);
        jobs.push(...collections.map(c=>()=>this.pool(c).then(ps=>ps.map(p=>({...p,contextual:true})))));
        // Non sovraccaricare la rete: massimo tre fonti in parallelo.
        let cursor=0;
        await Promise.all(Array.from({length:3},async()=>{while(cursor<jobs.length && this.controller===controller){const job=jobs[cursor++];try{candidates.push(...await bounded(job()));}catch{}}}));
        if(this.controller!==controller)return;
        const data=this.dataset.personalize==='true'?history():empty();
        const selected=ranking.selectCart(candidates,{anchors:anchors.map(a=>a.product),history:data.products.slice(0,3),seen:data.seen,limit:Math.min(this.hasAttribute('data-outfit')?32:12,Number(this.dataset.limit)||10),variety:Number(this.dataset.variety)/100});
        if (!this.hasAttribute('data-outfit')) await prepareCards(selected);
        if(this.controller!==controller)return;
        await this.render('related',selected,controller);
        if(this.controller!==controller)return;
        if(allowed() && this.dataset.personalize==='true'){const updated=history();updated.seen=[...selected.map(p=>p.id),...updated.seen].slice(0,32);save(updated);}
        this.dataset.loaded='true';
      } catch { if(this.controller===controller)await this.render('related',[],controller); }
      finally {if(this.controller===controller)this.removeAttribute('aria-busy');}
    }
    async refresh() {
      if (!this.started || !this.isConnected) return;
      if(this.context.mode==='cart')return this.refreshCart();
      const controller=this.controller={};
      const signal=undefined;
      const current=this.context.product;
      if (!current) { return; }
      const limit=Math.min(12,Math.max(4,Number(this.dataset.limit)||8));
      const data=this.dataset.personalize==='true' ? history() : empty();
      const recent=data.products.filter(p=>String(p.id)!==String(current.id)).slice(0,3);
      const recURL = (id,intent) => root+`recommendations/products.json?product_id=${encodeURIComponent(id)}&intent=${intent}&limit=10`;
      const collections=[...this.context.collections];
      if (data.collections[0] && !collections.some(c=>c.handle===data.collections[0].handle)) collections.push(data.collections[0]);
      this.setAttribute('aria-busy','true');
      try {
        const jobs=[json(recURL(current.id,'related'),signal), this.dataset.complementary==='true' ? json(recURL(current.id,'complementary'),signal) : Promise.resolve({products:[]}),json(root+'cart.js',signal),...collections.slice(0,3).map(c=>this.pool(c,signal))];
        jobs.push(this.similar(current,signal));
        if (recent[0]) jobs.push(json(recURL(recent[0].id,'related'),signal).then(d=>d.products||[]));
        const results=await Promise.allSettled(jobs.map(bounded));
        if (this.controller!==controller) return;
        const value=(i,fallback)=>results[i]?.status==='fulfilled'?results[i].value:fallback;
        const excluded=(value(2,{items:[]}).items||[]).map(p=>p.product_id);
        const complementary=[];
        for(const p of value(1,{products:[]}).products||[]) {
          if(p.available && String(p.id)!==String(current.id) && !excluded.map(String).includes(String(p.id)) && !complementary.some(item=>String(item.id)===String(p.id))) complementary.push(p);
          if(complementary.length>=Math.min(limit,10))break;
        }
        const candidates=(value(0,{products:[]}).products||[]).map(p=>({...p,native:true}));
        for(let i=3;i<results.length;i++) candidates.push(...value(i,[]).map(p=>({...p,contextual:i<3+this.context.collections.length})));
        const banned=[...excluded,...complementary.map(p=>p.id)];
        if (this.dataset.fallback && candidates.filter(p=>p.available&&!banned.includes(p.id)&&p.id!==current.id).length<limit) candidates.push(...await bounded(this.pool({handle:this.dataset.fallback},signal)).catch(()=>[]));
        if (this.controller!==controller) return;
        const selected=window.ExtroRecommendationRanking.select(candidates,{current,history:recent,excluded:banned,seen:data.seen,limit,variety:Number(this.dataset.variety)/100});
        await prepareCards([...complementary,...selected]);
        if (this.controller!==controller) return;
        await Promise.all([this.render('complementary',complementary,controller),this.render('related',selected,controller)]);
        if (this.controller!==controller) return;
        if (allowed() && this.dataset.personalize==='true') {
          const updated=history();updated.seen=[...selected.map(p=>p.id),...updated.seen].slice(0,32);save(updated);
        }
        this.dataset.loaded='true';
      } catch(error) {
        if (error.name!=='AbortError') console.warn('Anita ti consiglia: fonte non disponibile');
      } finally { if(this.controller===controller)this.removeAttribute('aria-busy'); }
    }
    async render(group,products,controller,standard=false) {
      if (this.hasAttribute('data-outfit') && !standard) {
        if (this.controller===controller && this.isConnected) this.closest('extro-cart-outfit')?.setProducts(products, async () => {
          await prepareCards(products);
          await this.render(group,products,controller,true);
        });
        return;
      }
      const wrapper=this.querySelector(`[data-group="${group}"]`),rail=wrapper.querySelector('.er-rail');
      const cards=await Promise.allSettled(products.map(standardCard));
      if (this.controller!==controller || !this.isConnected) return;
      const fragment=document.createDocumentFragment();
      cards.forEach((result,index)=>{
        if (result.status!=='fulfilled') return;
        const product=products[index],card=result.value.cloneNode(true);
        const prefix=`${this.cardPrefix}-${group}-${product.id}-`;
        // ID distinti anche con più moduli; preserva quick buy e controlli del tema.
        const ids=new Map();
        card.querySelectorAll('[id]').forEach(node=>{ids.set(node.id,prefix+node.id);node.id=prefix+node.id;});
        card.querySelectorAll('[aria-controls],[for],[form],[aria-labelledby]').forEach(node=>{
          for(const attr of ['aria-controls','for','form','aria-labelledby']) {
            if(node.hasAttribute(attr)) node.setAttribute(attr,node.getAttribute(attr).split(' ').map(id=>ids.get(id)||id).join(' '));
          }
        });
        const url=localProductURL(product);
        card.querySelectorAll('a[href]').forEach(link=>{
          if(new URL(link.getAttribute('href'),location.origin).pathname===new URL(url).pathname) link.href=url;
        });
        const item=document.createElement('div');item.className='er-card';item.dataset.productId=product.id;
        item.append(card);fragment.append(item);
      });
      rail.replaceChildren(fragment);wrapper.hidden=!rail.children.length;
      this.updateScrollProgress?.();
    }
  }
  customElements.define('extro-recommendations',Recommendations);
})();
